import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deletePortfolioLink } from '@app/store/actions/yat-page-item-actions';

import { USER_YAT_PAGE_LINKS } from './useGetYatPageLinks';

interface DeletePortfolioLinkProps {
    pageId: string;
    itemId: string;
}

export function useRemoveLinkMutation() {
    const queryClient = useQueryClient();

    const handleOnSuccess = () => {
        setTimeout(() => {
            queryClient.invalidateQueries({
                predicate: ({ queryKey }) => queryKey[0] === USER_YAT_PAGE_LINKS,
                refetchType: 'all',
            });
        }, 1000);
    };

    return useMutation({
        mutationFn: ({ pageId, itemId }: DeletePortfolioLinkProps) => deletePortfolioLink(itemId, pageId),
        onSuccess: handleOnSuccess,
    });
}
